import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import debounce from '../../../../../packs/shared/debounce';

export default class extends Controller {
  static targets = ['groupNumber'];

  static values = { groupsUrl: String };

  connect() {
    this.debouncedGroupNumberChange = debounce(this.handleGroupNumberChange.bind(this), 300);
  }

  groupNumberChanged() {
    this.debouncedGroupNumberChange();
  }

  handleGroupNumberChange() {
    const newValue = this.groupNumberTarget.value.trim();
    this.fetchGroups(newValue);
  }

  fetchGroups(groupNumber) {
    const url = new URL(this.groupsUrlValue, window.location.origin);
    url.searchParams.set('group_number', groupNumber);

    fetch(url)
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
